import type { Alert } from '@api';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';
import { useKgInsight } from '@terminal/react-query-hooks/insights/useKgInsight';
import { isEarningsCategory } from '@terminal/widgets/catalyst-insights-drawer/catalyst-widget/utils/catalyst-widget-utils';

interface UseKgInsightCardDataArgs {
  alertEvent: Alert;
  isNewEarningsTabEnabled: boolean;
}

export const useKgInsightCardData = ({
  alertEvent,
  isNewEarningsTabEnabled,
}: UseKgInsightCardDataArgs) => {
  const shouldLoadKgInsight =
    alertEvent.source_type === 'kg-insight' && isNewEarningsTabEnabled;
  const { data: kgInsight, isLoading: isKgInsightLoading } = useKgInsight(
    shouldLoadKgInsight ? alertEvent.source_id : ''
  );
  const category =
    kgInsight && isEarningsCategory(kgInsight.category)
      ? kgInsight.category
      : undefined;
  const entityTag =
    kgInsight?.subject.type === 'entity' ? kgInsight.subject.id : '';
  const isKgInsightCard = shouldLoadKgInsight && !!category && !!entityTag;
  const { data: entityData, isLoading: isEntityLoading } = useEntity(
    isKgInsightCard ? entityTag : undefined
  );

  return {
    category,
    entity: entityData?.data,
    entityTag,
    insight: kgInsight,
    isKgInsightCard,
    isLoading: isKgInsightLoading || (isKgInsightCard && isEntityLoading),
    shouldLoadKgInsight,
  };
};
